import React from 'react';
import { Translation } from 'react-i18next';

import { Icon } from 'semantic-ui-react';

import './MarkdownHintHelperPopup.css';

const MarkdownHintHelperPopup = () => (
  <Translation>
    {(t) => (
      <div className="markdown-hint-helper-popup__component">
        {/*<div className="row">*/}
        {/*  <div className="icon">*/}
        {/*    <Icon name="bold" />*/}
        {/*  </div>*/}
        {/*  <div className="example">*/}
        {/*    <span className="symbol">**</span>*/}
        {/*    Bold*/}
        {/*    <span className="symbol">**</span>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="row">
          <div className="icon">
            <Icon name="italic" />
          </div>
          <div className="example">
            <span className="symbol">*</span>
            {t("Italic")}
            <span className="symbol">*</span>
          </div>
        </div>
        <div className="row">
          <div className="icon">
            <Icon name="code" />
          </div>
          <div className="example">
            <span className="symbol">`</span>
            {t("Code")}
            <span className="symbol">`</span>
          </div>
        </div>
        <div className="row">
          <div className="icon">
            <Icon name="linkify" />
          </div>
          <div className="example">
            <span className="symbol">[</span>
            {t("Link Title")}
            <span className="symbol">](</span>
            URL
            <span className="symbol">)</span>
          </div>
        </div>
        <div className="row">
          <div className="icon">
            <Icon name="header" size="small">1</Icon>
          </div>
          <div className="example">
            <span className="symbol"># </span>
            {t("Large heading")}
          </div>
        </div>
        <div className="row">
          <div className="icon">
            <Icon name="header" size="small">2</Icon>
          </div>
          <div className="example">
            <span className="symbol">## </span>
            {t("Medium heading")}
          </div>
        </div>
        <div className="row">
          <div className="icon">
            <Icon name="header" size="small">3</Icon>
          </div>
          <div className="example">
            <span className="symbol">### </span>
            {t("Small heading")}
          </div>
        </div>
        <div className="row">
          <div className="icon">
            <Icon name="list" />
          </div>
          <div className="example">
            <span className="symbol">* </span>
            {t("Bulleted list")}
          </div>
        </div>
        <div className="row">
          <div className="icon clear-formatting" />
          <div className="example">
            {t("Clear-Formatting")}
          </div>
        </div>
      </div>
    )}
  </Translation>
);

export default MarkdownHintHelperPopup;
